module.exports = __webpack_public_path__ + "static/img/a056.080b9c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a056.jpg
// module id = d9W2
// module chunks = 0